import { Editor, TLShapeId } from '@tldraw/tldraw'
import { ImageShapeUtil } from 'components/VisualStudioPlayground/Shapes/ImageShape/ImageShapeUtil'
import { ImageShape } from 'components/VisualStudioPlayground/Shapes/ImageShape/Types'
import { useCreateMediaVariantSync } from 'hooks/queries/mediaFiles/useCreateMediaVariant'
import { useRootStore } from 'stores/RootStore'
import { createVariantAsset } from '../UploadsTab/insertImage'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'

interface Props {
  editor: Editor
  shape: ImageShape
}

export const useToggleRemoveBackground = ({ editor, shape }: Props) => {
  const { designStore } = useRootStore()
  const value = Boolean(shape.props.removeBackground)
  const asset = shape.props.assetId ? editor.getAsset(shape.props.assetId) : undefined
  const mediaFileId = asset?.meta.mediaFileId as string | undefined
  const util = editor.getShapeUtil(shape) as ImageShapeUtil
  const isDisabled = !util.canRemoveBackground(shape)
  const createMediaVariant = useCreateMediaVariantSync()

  const toggle = async () => {
    if (!mediaFileId) return
    try {
      designStore?.setProcessingShapeId(shape.parentId as TLShapeId)
      const shouldEnable = !value
      if (shouldEnable) {
        const variant = await createMediaVariant.mutateAsync({
          mediaFileId,
          transformations: { remove_background: { crop: true } },
        })
        const asset = createVariantAsset(mediaFileId, variant)
        editor.createAssets([asset])
      }
      util.setRemoveBackground(shape, !value)
    } catch (e) {
      showToastMessage('An error occurred, our team has been notified!', 'error')
    } finally {
      designStore?.setProcessingShapeId(undefined)
    }
  }

  return { toggle, value, isDisabled }
}
